import React from 'react';

import routes from 'sitewide-js/core_pre_webpack/routes';
import ExportFormatModal from 'js/export_format/ExportFormatModal';

interface Props {
  apiPath: string;
  recordCount: number;
}

const ReadersExportModal: React.FC<Props> = ({ apiPath, recordCount }) => (
  <ExportFormatModal
    apiPath={apiPath}
    breadcrumbLabel="Readers"
    csvDescription="One row per reader, with timestamps and locations."
    recordCount={recordCount}
    recordNoun="reader"
    calloutTitle="Premium reveals every reader of your work — not just a public summary."
    calloutDesc="Names, institutions, and what they read. Renew Premium to keep tracking who is engaging with your research."
    resolveDownloadHref={(id) =>
      routes.download_readers_export_url({ readers_export_id: id })
    }
  />
);

export default ReadersExportModal;
